// CAROUSEL
export const SET_CAROUSEL_INDEX = "SET_CAROUSEL_INDEX";
export const CAROUSEL_LOADING = "CAROUSEL_LOADING";
export const SET_INDEX_LABEL = "SET_INDEX_LABEL";
export const SET_SLIDE_MAX = "SET_SLIDE_MAX";
export const IS_FROM_INPUT = "IS_FROM_INPUT";
export const SET_FIRST_LOAD = "SET_FIRST_LOAD";
export const SET_ZOOM_LEVEL = "SET_ZOOM_LEVEL";
export const SET_REF_ZOOM = "SET_REF_ZOOM";
export const SET_BUTTON_DISABLED = "SET_BUTTON_DISABLED";
export const IS_MODAL_OPEN = "IS_MODAL_OPEN";
export const IS_RIGHT_SIDEBAR_OPEN = "IS_RIGHT_SIDEBAR_OPEN";
export const SET_VERTICAL_PAGES = "SET_VERTICAL_PAGES";
export const SET_MARKER_CLICKABLE = "SET_MARKER_CLICKABLE";
export const SET_SEARCHBAR_OPEN = "SET_SEARCHBAR_OPEN";
export const SET_SEARCHBAR_CLOSE = "SET_SEARCHBAR_CLOSE";
//COOKIE
export const SET_COOKIE_INFO = "SET_COOKIE_INFO";

//FLOATING MENU
export const IS_MENU_OPEN = "IS_MENU_OPEN";

//VIDEO MANAGER
export const SET_VISIBILITY_VIDEO = "SET_VISIBILITY_VIDEO";
//MODAL
export const OPEN_INTERACTIVITY_MODAL = "OPEN_INTERACTIVITY_MODAL";
export const CLOSE_INTERACTIVITY_MODAL = "CLOSE_INTERACTIVITY_MODAL";
export const OPEN_RELATED = "OPEN_RELATED";
export const SET_ERROR_MODAL = "SET_ERROR_MODAL";
export const OPEN_INTERACTIVITY_MODAL_STATIC =
  "OPEN_INTERACTIVITY_MODAL_STATIC";
export const START_LOADING_MODAL = "START_LOADING_MODAL";
export const END_LOADING_MODAL = "END_LOADING_MODAL";
export const RESET_MODAL_DATA = "RESET_MODAL_DATA";
export const SET_CURRENT_MARKER = "SET_CURRENT_MARKER";

// Person.name
export const LOGIN_JWT = "LOGIN_JWT";
export const LOGIN_JWT_SUCCESS = "LOGIN_JWT_SUCCESS";
export const LOGOUT_JWT = "LOGOUT_JWT";

export const TOGGLE_JWT_MODAL = "TOGGLE_JWT_MODAL";
export const LOGIN_JWT_FAIL = "LOGIN_JWT_FAIL";
export const REGISTER_JWT_FAIL = "REGISTER_JWT_FAIL";
export const START_JWT_LOADING = "START_JWT_LOADING";
export const END_JWT_LOADING = "END_JWT_LOADING";
export const GET_JWT_PROFILE = "GET_JWT_PROFILE";
export const LOADING_JWT_PROFILE = "LOADING_JWT_PROFILE";
export const GET_JWT_PROFILE_FAIL = "GET_JWT_PROFILE_FAIL";
export const TOGGLE_USER_MODAL = "TOGGLE_USER_MODAL";
export const SUCCESS_SIGNUP_JWT = "SUCCESS_SIGNUP_JWT";

// PROFILE
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_FAIL = "DELETE_ACCOUNT_FAIL";
export const REQUEST_PASSWORD_RESET_SUCCESS = "REQUEST_PASSWORD_RESET_SUCCESS";
export const REQUEST_PASSWORD_RESET_FAIL = "REQUEST_PASSWORD_RESET_FAIL";
export const SET_LOGIN_MODAL_VIEW = "SET_LOGIN_MODAL_VIEW";

// CHECKOUT
export const SET_CHECKOUT_STEP = "SET_CHECKOUT_STEP";
export const SET_DELIVERY_METHOD = "SET_DELIVERY_METHOD";
export const SET_SHIPPING_DATA = "SET_SHIPPING_DATA";
export const SET_SELECTED_STORE = "SET_SELECTED_STORE";
export const SET_PICKUP_DATE = "SET_PICKUP_DATE";
export const SET_SELECTED_SLOT = "SET_SELECTED_SLOT";
export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
export const RESET_CHECKOUT = "RESET_CHECKOUT";
export const FETCH_MARKETS_SUCCESS = "FETCH_MARKETS_SUCCESS";
export const FETCH_SLOTS_SUCCESS = "FETCH_SLOTS_SUCCESS";
export const SET_SHIPPING_COST = "SET_SHIPPING_COST";
export const SHIPPING_COST_LOADING = "SHIPPING_COST_LOADING";
export const SHIPPING_COST_ERROR = "SHIPPING_COST_ERROR";
export const CHECK_CART_LOADING = "CHECK_CART_LOADING";
export const CHECK_CART_SUCCESS = "CHECK_CART_SUCCESS";
export const CHECK_CART_FAIL = "CHECK_CART_FAIL";
export const CONFIRM_CART_LOADING = "CONFIRM_CART_LOADING";
export const CONFIRM_CART_SUCCESS = "CONFIRM_CART_SUCCESS";
export const CONFIRM_CART_FAIL = "CONFIRM_CART_FAIL";
export const SAVE_CART_SUCCESS = "SAVE_CART_SUCCESS";
export const SYNC_CART_FROM_SERVER = "SYNC_CART_FROM_SERVER";
export const SET_ECOMMERCE_CONFIG = "SET_ECOMMERCE_CONFIG";
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";

// PRICES
export const START_LOADING_PRICES = "START_LOADING_PRICES";
export const END_LOADING_PRICES = "END_LOADING_PRICES";
export const GET_PRICES = "GET_PRICES";
